import { FormEvent, useEffect, useState } from 'react';
import { TrackerList } from '../components/TrackerList';
import { useTrackerStore } from '../stores/trackerStore';
import { useBankrollStore } from '../stores/bankrollStore';

const money = (value: number) => value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function TrackerScreen() {
  const { load, entries } = useTrackerStore();
  const { load: loadBankroll, state: bank, setInitial } = useBankrollStore();
  const [editingBank, setEditingBank] = useState(false);
  const [bankValue, setBankValue] = useState('');

  useEffect(() => { void load(); void loadBankroll(); }, [load, loadBankroll]);

  const picks = entries.filter(entry => entry.type === 'pick').map(entry => entry.data);
  const parlays = entries.filter(entry => entry.type === 'parlay').map(entry => entry.data);
  const spent = entries.reduce((sum, entry) => sum + entry.data.stake, 0);
  const returns = entries.reduce((sum, entry) => {
    if (entry.type === 'pick') {
      if (entry.data.status === 'won') return sum + entry.data.stake * entry.data.odds;
      if (entry.data.status === 'push' || entry.data.status === 'void') return sum + entry.data.stake;
      return sum;
    }
    if (entry.data.status === 'green') return sum + entry.data.potentialReturn;
    if (entry.data.status === 'void') return sum + entry.data.stake;
    return sum;
  }, 0);
  const available = bank.initial - spent + returns;
  const profit = picks.reduce((sum, pick) => sum + (pick.status === 'won' ? pick.stake * (pick.odds - 1) : pick.status === 'lost' ? -pick.stake : 0), 0)
    + parlays.reduce((sum, parlay) => sum + (parlay.status === 'green' ? parlay.potentialReturn - parlay.stake : parlay.status === 'red' ? -parlay.stake : 0), 0);
  const resolvedStake = picks.filter(p => p.status === 'won' || p.status === 'lost').reduce((sum, pick) => sum + pick.stake, 0)
    + parlays.filter(p => p.status === 'green' || p.status === 'red').reduce((sum, parlay) => sum + parlay.stake, 0);
  const roi = resolvedStake ? profit / resolvedStake * 100 : 0;

  const saveBank = async (event: FormEvent) => {
    event.preventDefault();
    await setInitial(Number(bankValue.replace(',', '.')) || 0);
    setEditingBank(false);
  };

  return <main className="screen tracker-screen">
    <header className="tracker-hero">
      <span className="tracker-eyebrow">TRACKER · CONFERIDOS</span>
      <h1>RESULTADOS<br/><em>REAIS</em></h1>
      <p>Cada pick que você anotou é conferida pelas estatísticas do jogo: green, red ou devolvida. O lucro conta 1 unidade por pick, na odd salva.</p>
    </header>

    <section className="tracker-bank-card">
      <header><div><small>BANCA DISPONÍVEL</small><strong>R$ {money(available)}</strong></div><button onClick={() => { setBankValue(bank.initial ? String(bank.initial) : ''); setEditingBank(value => !value); }}>{editingBank ? 'Fechar' : 'Definir banca'}</button></header>
      <div className="tracker-bank-stats"><span><small>PNL RESOLVIDO</small><b className={profit >= 0 ? 'positive' : 'negative'}>R$ {money(profit)}</b></span><span><small>ROI</small><b className={roi >= 0 ? 'positive' : 'negative'}>{roi >= 0 ? '+' : ''}{money(roi)}%</b></span></div>
      {editingBank && <form onSubmit={saveBank}><label>Banca inicial (R$)<input inputMode="decimal" value={bankValue} onChange={event => setBankValue(event.target.value)} placeholder="100,00"/></label><button type="submit">SALVAR BANCA</button></form>}
      <p className="tracker-bank-note">Banca disponível = inicial − stakes registrados + retornos pagos. PnL e ROI consideram apenas apostas resolvidas.</p>
    </section>

    <TrackerList />
  </main>;
}
